import React, { useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { samplePages } from '../data/landing';
interface SamplesSectionProps {
  layout?: 'carousel' | 'grid';
}
const navButtonClass = 'flex h-12 w-12 items-center justify-center rounded-full border border-brand/30 bg-white text-brand transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:bg-brand-soft focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-stone-900';
export function SamplesSection({
  layout = 'carousel'
}: SamplesSectionProps) {
  const trackRef = useRef<HTMLUListElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollTo = (index: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(samplePages.length - 1, index));
    const item = track.children[clamped] as HTMLElement | undefined;
    if (item) {
      track.scrollTo({
        left: item.offsetLeft - track.offsetLeft,
        behavior: 'smooth'
      });
    }
    setActiveIndex(clamped);
  };
  return <section aria-labelledby="muestras" className="bg-stone-100" data-id="element-151" data-mp="1qc2hmkct4lco">
      <div className="mx-auto max-w-6xl bg-stone-50 px-5 py-20 lg:py-24" data-id="element-152" data-mp="1qarf0nv3ljn5">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-153" data-mp="1v3u8yx3sev3v">
          <SectionHeading id="muestras" align="left" title={<>
                Mirá el material <span className="italic text-brand" data-id="element-155" data-mp="250gtfks7bk5d">por dentro</span>
              </>} intro="Páginas reales del MegaPack: un tema por hoja, en formato A4." data-id="element-154" data-mp="202ouw7x1wzs7" />

          {layout === 'carousel' ? <div className="flex shrink-0 gap-3" data-id="element-156" data-mp="2e1oe301somgz">
              <button type="button" onClick={() => scrollTo(activeIndex - 1)} aria-label="Ver ejemplo anterior" className={navButtonClass} data-id="element-157" data-mp="2e0d9wz4ftcpc">
                <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-158" data-mp="jnniqp5gehln" />
              </button>
              <button type="button" onClick={() => scrollTo(activeIndex + 1)} aria-label="Ver ejemplo siguiente" className={navButtonClass} data-id="element-159" data-mp="jpgpe4g2h1tn">
                <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-160" data-mp="1i0hz0b0nnod0" />
              </button>
            </div> : null}
        </div>

        <ul ref={trackRef} className={layout === 'carousel' ? 'no-scrollbar mt-12 flex snap-x snap-mandatory gap-6 overflow-x-auto pb-2' : 'mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-3'} data-id="element-161" data-mp="1w0j1fuwkj3ul">
          {samplePages.map(sample => <li key={sample.level} className={layout === 'carousel' ? 'flex w-[15.5rem] shrink-0 snap-start flex-col sm:w-[18rem]' : 'flex flex-col'} data-id="element-162" data-mp="25v2kl2edqdc2">
              <div className="overflow-hidden rounded-lg border border-stone-200 bg-white" data-id="element-163" data-mp="2eony6iet5ojw">
                <img src={sample.image} alt={`${sample.level}: ${sample.title}`} className="aspect-[707/1000] w-full object-contain" loading="lazy" data-id="element-164" data-mp="2ap6rjlnnald5" />
              </div>
              <span className="mt-5 text-xs font-semibold uppercase tracking-[0.16em] text-brand" data-id="element-165" data-mp="2jp27e3s5b4ji">
                {sample.level}
              </span>
              <h3 className="mt-2 font-serif text-xl leading-snug text-stone-900" data-id="element-166" data-mp="33b562jud9mlx">{sample.title}</h3>
              {sample.body ? <p className="mt-2 text-sm leading-relaxed text-stone-600" data-id="element-167" data-mp="387m4q7z6zjd9">{sample.body}</p> : null}
            </li>)}
        </ul>
      </div>
    </section>;
}